import { useQuery } from "@tanstack/react-query";
import { getProfile, getProfileDomains, getProfiles, getProfilesForSupervisor } from "../api/profiles";

export const useProfileDomainsQuery = (id) => {
  return useQuery({
    queryKey: ["profileDomains", id],
    queryFn: () => getProfileDomains(id),
    isEnabled: !!id, // Only run the query if id is valid
  });
};

export const useProfilesForSupervisorQuery = (namedFilter, supervisorId, sortOrder) => {
  return useQuery({
    queryKey: ["profilesForSupervisor", namedFilter, supervisorId, sortOrder],
    queryFn: () => getProfilesForSupervisor(namedFilter, supervisorId, sortOrder),
    enabled: !!supervisorId, // Only run the query if supervisorId is valid
  });
};

export const useProfileQuery = (profileId) => {
  return useQuery({
    queryKey: ["profile", profileId],
    queryFn: () => getProfile(profileId),
    enabled: !!profileId, // Only run the query if profileId is valid
  });
};

export const useProfilesQuery = (namedFilter) => {
  return useQuery({
    queryKey: ["profiles", namedFilter],
    queryFn: () => getProfiles(namedFilter),
  });
};
